import { calcSimilarity } from '../internal/similarity/calcSimilarity.ts';
import { CompSelectionProperty } from '../types.ts';

export function addSimilarityScores(
  properties: CompSelectionProperty[],
  subject: CompSelectionProperty,
) {
  for (const prop of properties) {
    prop.similarityScore = calcSimilarity(subject, prop);
  }
}
